module.exports = __webpack_public_path__ + "fonts/4f1d4a5.otf";